import { PageContent, PageHeader } from '@/components';
import { GlobalTagResourceGuard } from '@/features/authentication/_components/GlobalTagResourceGuard';
import { LocalTagResourceGuard } from '@/features/authentication/_components/LocalTagResourceGuard';
import { useTranslation } from 'react-i18next';
import { Route, Routes } from 'react-router';

import {
  CreateGlobalTagButton,
  CreateLocalTagButton,
  DrawerStateProvider,
  GlobalTagsPage,
  LocalTagsPage,
} from './components';

export const TagRoutes = () => {
  const { t } = useTranslation();

  return (
    <DrawerStateProvider>
      <Routes>
        <Route
          path="/global"
          element={
            <>
              <PageHeader
                title={t('scope-tags-page', { scope: t('global-tag') })}
                breadcrumbs={[
                  { title: t('scope-tags-page', { scope: t('global-tag') }) },
                ]}
                buttons={
                  <GlobalTagResourceGuard onlyEdit>
                    <CreateGlobalTagButton />
                  </GlobalTagResourceGuard>
                }
              />
              <PageContent>
                <GlobalTagsPage />
              </PageContent>
            </>
          }
        />
        <Route
          path="/local"
          element={
            <>
              <PageHeader
                title={t('scope-tags-page', { scope: t('local-tag') })}
                breadcrumbs={[
                  { title: t('scope-tags-page', { scope: t('local-tag') }) },
                ]}
                buttons={
                  <LocalTagResourceGuard onlyEdit>
                    <CreateLocalTagButton />
                  </LocalTagResourceGuard>
                }
              />
              <PageContent>
                <LocalTagsPage />
              </PageContent>
            </>
          }
        />
      </Routes>
    </DrawerStateProvider>
  );
};
